module.exports = __webpack_public_path__ + "static/img/bg3.30745a0f.png";